module.exports = __webpack_public_path__ + "static/recentProductsLayoutBack-d5bdcbabd473b26d4b982156234fb3f8.png";